/**
 * 宿泊施設のドロップボックス
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _ReservationPayState = {
  reservation_id: null,
  accommodation_fee_paid: false,
  accommodation_tax_paid: false
}

const ReservationPayState = Record(_ReservationPayState)

export { ReservationPayState }
